import apiClient from "../../api/apiClient";

/**
 * Category Service
 * Handles all API calls related to category management
 */

// ================= GET ALL CATEGORIES =================
export const getCategoriesApi = async (
  page: number,
  pageSize: number,
  tenantId: string,
  search: string
) => {
  const res = await apiClient.get("/categories", {
    params: {
      PageNumber: page,
      PageSize: pageSize,
      TenantId: tenantId,
      Search: search,
      tenantId,
    },
  });

  return res.data;
};

// ================= GET CATEGORY BY ID =================
export const getCategoryByIdApi = async (
  id: string,
  tenantId: string
) => {
  const res = await apiClient.get(
    `/categories/${id}`,
    {
      params: {
        tenantId,
      },
    }
  );

  return res.data;
};

// ================= CREATE CATEGORY =================
export const createCategoryApi = async (
  data: any,
  tenantId: string
) => {
  const res = await apiClient.post(
    "/categories",
    data,
    {
      params: {
        tenantId,
      },
    }
  );

  return res.data;
};

// ================= UPDATE CATEGORY =================
export const updateCategoryApi = async (
  data: any,
  tenantId: string
) => {
  const res = await apiClient.put(
    "/categories",
    data,
    {
      params: {
        tenantId,
      },
    }
  );

  return res.data;
};

// ================= DELETE CATEGORY =================
export const deleteCategoryApi = async (
  id: string,
  tenantId: string
) => {
  const res = await apiClient.delete(
    `/categories/${id}`,
    {
      params: {
        tenantId,
      },
    }
  );

  return res.data;
};

export const categoryService = {
  getCategoriesApi,
  getCategoryByIdApi,
  createCategoryApi,
  updateCategoryApi,
  deleteCategoryApi,
};